import { assign, createMachine } from "xstate"

const initialContext = {
  listaContribuyentes: [],
  optionsContribuyentes: [],
  loading: false,
  loadingContribuyentes: false,
  oContribuyente: {},
  mensajeExito: "",
  error: "",
}

const getParameterValue = (nombre, parameters) => {
  //

  // Verificamos que exista 'Parametros' y que sea un array.
  if (parameters && Array.isArray(parameters)) {
    // Buscamos el parámetro que tenga el nombre nombre.
    const mensajeParam = parameters.find(param => param.Nombre === nombre)
    // Si lo encontramos, retornamos su Valor; de lo contrario, una cadena vacía.
    return mensajeParam ? mensajeParam.Valor : ""
  }

  // Si no hay 'Parametros', devolvemos cadena vacía.
  return ""
}

const contribuyentesMachine = createMachine(
  {
    predictableActionArguments: true,
    context: initialContext,
    id: "contribuyentes",
    initial: "idle",
    states: {
      idle: {
        on: {
          "contribuyentes/PARAMETERS": {
            actions: ["setResponseParameters"],
          },
          "contribuyentes/UNSET_ERROR": {
            actions: ["unsetError"],
          },
          "contribuyentes/UNSET_MENSAJE_EXITO": {
            actions: ["unsetMensajeExito"],
          },
          "contribuyentes/LISTA": {
            actions: ["unsetError", "setLoadingContribuyentes"],
            target: "idle",
          },
          "contribuyentes/LISTASUCCESS": {
            actions: [
              "unsetError",
              "setlistaContribuyentes",
              "unsetLoadingContribuyentes",
            ],
            target: "idle",
          },
          "contribuyentes/LISTAFAIL": {
            actions: ["setError", "unsetLoadingContribuyentes"],
            target: "idle",
          },
          "contribuyentes/OPTIONS": {
            actions: ["unsetError", "setLoading"],
            target: "idle",
          },
          "contribuyentes/OPTIONSSUCCESS": {
            actions: ["unsetError", "setoptionsContribuyentes", "unsetLoading"],
            target: "idle",
          },
          "contribuyentes/OPTIONSFAIL": {
            actions: ["setError", "unsetLoading"],
            target: "idle",
          },
          "contribuyentes/BUSQUEDA": {
            actions: ["unsetError", "setLoadingContribuyentes"],
            target: "idle",
          },
          "contribuyentes/BUSQUEDASUCCESS": {
            actions: [
              "unsetError",
              "setlistaContribuyentes",
              "unsetLoadingContribuyentes",
            ],
            target: "idle",
          },
          "contribuyentes/BUSQUEDAFAIL": {
            actions: ["setError", "unsetLoadingContribuyentes"],
            target: "idle",
          },
          "contribuyentes/CREATE": {
            actions: ["unsetError", "setLoading"],
            target: "idle",
          },
          "contribuyentes/CREATESUCCESS": {
            actions: ["unsetError", "setoContribuyente", "unsetLoading"],
            target: "idle",
          },
          "contribuyentes/CREATEFAIL": {
            actions: ["setError", "unsetLoading"],
            target: "idle",
          },
          "contribuyentes/UPDATE": {
            actions: ["unsetError", "setLoading"],
            target: "idle",
          },
          "contribuyentes/UPDATESUCCESS": {
            actions: ["unsetError", "setoContribuyente", "unsetLoading"],
            target: "idle",
          },
          "contribuyentes/UPDATEFAIL": {
            actions: ["setError", "unsetLoading"],
            target: "idle",
          },
          "contribuyentes/DELETE": {
            actions: ["unsetError", "setLoading"],
            target: "idle",
          },
          "contribuyentes/DELETESUCCESS": {
            actions: ["unsetError", "unsetoContribuyente", "unsetLoading"],
            target: "idle",
          },
          "contribuyentes/DELETEFAIL": {
            actions: ["setError", "unsetLoading"],
            target: "idle",
          },
        },
      },
    },
  },
  {
    actions: {
      resetMachine: assign(initialContext),
      setlistaContribuyentes: assign({
        listaContribuyentes: (_, event) => event.payload.data,
      }),
      unsetlistaContribuyentes: assign({
        listaContribuyentes: [],
      }),
      setoptionsContribuyentes: assign({
        optionsContribuyentes: (_, event) => event.payload.data,
      }),
      unsetoptionsContribuyentes: assign({
        optionsContribuyentes: [],
      }),
      setResponseParameters: assign({
        mensajeExito: (_, event) => {
          if (event.payload && event.payload.parameters) {
            return getParameterValue(
              "Mensaje_Exito",
              event.payload.parameters || []
            )
          }
        },
      }),
      unsetMensajeExito: assign({
        mensajeExito: "",
      }),
      setoContribuyente: assign({
        oContribuyente: (_, event) => event.payload.data,
      }),
      unsetoContribuyente: assign({
        oContribuyente: { id_Contribuyente: -1 },
      }),
      setNotificacion: assign({
        error: (_, event) => {
          console.log("setNotificacion")
          return ""
        },
      }),
      setError: assign({
        error: (_, event) => {
          console.log(event.payload)
          return event.payload.response?.data?.Mensaje_Error
            ? event.payload.response?.data?.Mensaje_Error
            : event.payload.message
            ? event.payload.message
            : event.payload
            ? event.payload
            : "Ocurrió un error!"
        },
      }),
      unsetError: assign({
        error: null,
      }),
      setLoading: assign({
        loading: true,
      }),
      unsetLoading: assign({
        loading: false,
      }),
      setLoadingContribuyentes: assign({
        loadingContribuyentes: true,
      }),
      unsetLoadingContribuyentes: assign({
        loadingContribuyentes: false,
      }),
    },
  }
)

export default contribuyentesMachine
